import Cookies from 'js-cookie'
import Config from '@/api/config'
const TokenKey = 'Admin-Token'
const rootDomain = Config.rootDomain

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  if (rootDomain) {
    return Cookies.set(TokenKey, token, { domain: rootDomain })
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken() {
  if (rootDomain) {
    return Cookies.remove(TokenKey, { domain: rootDomain })
  } else {
    return Cookies.remove(TokenKey)
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js